import { Button, Flex } from "antd";
import { useNavigate } from "react-router";
import Filters from "../../courses/filters";
import RightIcon from "../_icons/RightIcon";

export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="bg-gradient-to-l from-teal-700 to-gray-800 py-20 relative">
      <div className="container mini-container relative">
        <div>
          <h1 className="text-theme-white-900 text-2xl lg:text-4xl font-bold text-center">
            আমাদের সাথেই চাকরির যাত্রা শুরু করুন
          </h1>
          <p className="mt-3 text-center text-theme-white-900 text-sm lg:text-base font-medium ">
            কারিগরি, আইটি, হসপিটালিটি, হেলথকেয়ার সহ শতাধিক কোর্স থেকে নিজের
            পছন্দের ট্রেনিং নিন
          </p>

          <Flex justify="center" align="center">
            <Button
              type="primary"
              size="middle"
              className="!bg-transparent !border-none !text-theme-yellow-400 text-base lg:text-lg font-medium"
              onClick={() => navigate("/courses")}
            >
              <RightIcon className="!text-theme-yellow-400 text-base lg:text-lg pb-1" />{" "}
              ফিরে যান
            </Button>
          </Flex>
        </div>
        <Filters />
      </div>
    </section>
  );
}
